import { nextArrow, prevArrow } from "../utilities/slick-arrows";

jQuery("[data-card-slider=homepage-banner]").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    slide: ".slider-item",
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    rows: 0,
    focusOnSelect: true,
    nextArrow,
    prevArrow,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                dots: false,
            },
        },
    ],
});
